export const dataHooks = {
  getStartedButton: 'get-started-button',
};
